import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
export default {
  data: function data() {
    return {
      isShowDELIVERY_NO: true,
      // 输入送货单号
      isShowVENDOR_CODE: true,
      // 输入供应商代码
      isShowVENDOR: true,
      // 输入供应商
      isShowSeach: true,
      // 查询
      isShowAdd: true,
      // 新增
      isShowExport: false,
      // 数据导出
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowAddRow: false,
      // 新增明细
      isShowEditOrder: false,
      // 修改明细
      isShowAuditOrder: false,
      // 审核
      isShowUnAuditOrder: false,
      // 反审核
      isShowPrinter: false,
      // 打印
      isShowNext: true,
      // 上一张下一张
      isShowCancellation: false,
      // 作废
      isShowCancel: false,
      // 取消
      isShowSelectOrder: false,
      // 选择送货单
      isCreatePartBarcode: false,
      // 生成标签
      isShowDetailExport: false,
      //明细导出
      VENDOR_CODE: null,
      // 供应商
      selectLoading: false,
      vendorOptions: [],
      DELIVERY_NO: null,
      // 送货单号
      OrderList: [],
      // 单据列表
      currentIndex: null,
      nextIndex: null,
      orderStatus: null,
      // 单据状态
      orderInfo: {} // 单据内容

    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onClickDELIVERY_NO', function (data, currentIndex, OrderList) {
      // console.log('TabelToolBar---data',data);
      // console.log('TabelToolBar---currentIndex',currentIndex);
      // console.log('TabelToolBar---OrderList',OrderList);
      _this.orderInfo = data;
      _this.OrderList = OrderList;
      _this.currentIndex = currentIndex;

      _this.controlBtnShow(data.STATUS);
    }); // 监听审核成功

    this.Bus.on('AuditOrderSuccess', function () {
      _this.controlBtnShow(2);
    }); // 监听反审核成功

    this.Bus.on('UnCheckBillOrderSuccess', function () {
      _this.controlBtnShow(1);
    }); // 监听作废成功

    this.Bus.on('CancelBillSuccess', function () {
      _this.controlBtnShow(3);
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/MaintainDeliveryNote2', ['setOrderStatu'])), {}, {
    // 明细导出
    handleDetailExport: function handleDetailExport() {
      this.$emit('onHandleDetailExport');
    },
    // 设置状态
    setStatus: function setStatus(status) {
      // console.log(status);
      this.controlBtnShow(status);
    },
    // 点击打印外箱标签
    handlePrintOuterBoxLabel: function handlePrintOuterBoxLabel() {
      // this.Bus.emit('onPrintOuterBoxLabel')
      this.$emit('onPrintOuterBoxLabel_OuterBoxLabelManagement');
    },
    // 点击导出--列表
    handelExportListData: function handelExportListData() {
      console.log(1);
      this.Bus.emit('onHandelExportListData');
    },
    // 点击作废
    handelCancelBill: function handelCancelBill() {
      this.Bus.emit('onCancelBillOrder');
    },
    // 点击反审核
    UnCheckBillOrder: function UnCheckBillOrder() {
      this.Bus.emit('onUnCheckBillOrder');
    },
    // 点击生成标签
    handleCreatePartBarcode: function handleCreatePartBarcode() {
      // this.Bus.emit('onCreateOutBoxBarcode')
      this.$emit('onCreateOutBoxBarcode_OuterBoxLabelManagement');
    },
    // 点击选择送货单
    handleSelectOrder: function handleSelectOrder() {
      // this.Bus.emit('onHandleSelectOrder')
      this.$emit('onSelectOrder_OuterBoxLabelManagement');
    },
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      if (status === 1) {
        // 未确认
        this.isShowAuditOrder = true;
        this.isShowUnAuditOrder = false;
        this.isShowEditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = true;
      } else if (status === 2) {
        // 已审核
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = false;
      } else if (status === 3) {
        // 作废
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      } else if (status === 4) {
        // 在途
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowAuditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 5) {
        // 收货
        this.isShowPrinter = true;
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 9) {
        // 全关闭
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      }
    },
    // 点击上一张
    handleUpNextOrder: function handleUpNextOrder() {
      // console.log(this.currentIndex);
      // if(this.currentIndex === 0){
      //     this.$message.warning('没有上一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex -= 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('getBackOrder');
    },
    // 点击下一张
    handleDownNextOrder: function handleDownNextOrder() {
      // console.log(this.currentIndex);
      // if((this.currentIndex + 1) > this.OrderList.length - 1){
      //     this.$message.warning('没有下一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex += 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('nextOrder');
    },
    handleVendorChange: function handleVendorChange() {
      console.log(this.VENDOR_CODE);
    },
    // 点击查询
    handleSearch: function handleSearch() {
      this.Bus.emit('onSearchDeliveryOrder', this.VENDOR_CODE, this.DELIVERY_NO);
    },
    // 点击保存单据
    handleSaveOrder: function handleSaveOrder() {
      // this.Bus.emit('onSaveOuterBoxLabelOrder')
      this.$emit('onSave_OuterBoxLabelManagement');
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      this.Bus.emit('onHandleBlack_OuterBoxLabelManagement');
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {}
  }),
  watch: {
    // 内箱标签管理
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowDELIVERY_NO = true;
          this.isShowVENDOR_CODE = true;
          this.isShowVENDOR = true;
          this.isShowSeach = true;
          this.isShowAdd = false;
          this.isShowExport = true;
          this.isShowBlack = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowNext = false;
          this.isShowCancel = false;
          this.isShowSelectOrder = false;
          this.isShowPrinter = false;
          this.isShowNext = false;
          this.isShowDetailExport = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = true;
          this.isShowSelectOrder = true;
          this.isCreatePartBarcode = false;
          this.isShowPrinter = false;
          this.isShowNext = false;
          this.isShowDetailExport = false;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = false;
          this.isShowSelectOrder = false;
          this.isCreatePartBarcode = true;
          this.isShowPrinter = true;
          this.isShowNext = true;
          this.isShowDetailExport = true;
        } else if (nawValue === 'editOrder') {
          this.isShowDELIVERY_NO = false;
          this.isShowVENDOR_CODE = false;
          this.isShowVENDOR = false;
          this.isShowSeach = false;
          this.isShowAdd = false;
          this.isShowExport = false;
          this.isShowNext = false;
          this.isShowEditOrder = false;
          this.isShowAuditOrder = false;
          this.isShowCancellation = false;
          this.isShowBlack = false; // 返回

          this.isShowSave = false; // 保存

          this.isShowAddRow = false; // 新增明细

          this.isShowExport = false; // 数据导出

          this.isShowCancel = false; // 取消

          this.isShowNext = false;
          this.isShowDetailExport = false;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState', 'AnnouncementState'])),
  beforeDestroy: function beforeDestroy() {
    this.Bus.off('AuditOrderSuccess');
    this.Bus.off('UnCheckBillOrderSuccess');
    this.Bus.off('CancelBillSuccess');
    this.Bus.off('onClickDELIVERY_NO');
  }
};